module.exports = __webpack_public_path__ + "static/img/bible-enrichment-fellowship.c9f5d8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ministries/bible-enrichment-fellowship.jpg
// module id = 7FeL
// module chunks = 1